const stats = [
  { number: '15+', label: 'Years Experience', icon: 'ri-calendar-check-fill' },
  { number: '500+', label: 'Happy Customers', icon: 'ri-group-fill' },
  { number: 'Free', label: 'No-Obligation Quotes', icon: 'ri-file-list-3-fill' },
  { number: '100%', label: 'Certified & Insured', icon: 'ri-shield-check-fill' },
];

const accreditations = [
  { label: 'NAPIT Registered', icon: 'ri-award-fill' },
  { label: 'City & Guilds Qualified', icon: 'ri-graduation-cap-fill' },
  { label: 'Simply Business Insured', icon: 'ri-shield-check-fill' },
  { label: 'Trustmark Approved', icon: 'ri-verified-badge-fill' },
  { label: 'Part P Registered', icon: 'ri-file-text-fill' },
  { label: '18th Edition Certified', icon: 'ri-bookmark-fill' },
];

export default function TrustBadges() {
  return (
    <section className="bg-navy-800 py-14 font-body">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-gold-400 text-3xl`}></i>
              </div>
              <p className="font-heading font-extrabold text-gold-400 text-4xl leading-none mb-1">
                {stat.number}
              </p>
              <p className="text-gold-100/70 text-sm font-semibold uppercase tracking-wide">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {/* Accreditations strip */}
        <div className="border-t border-gold-400/20 pt-8">
          <p className="text-center text-gold-200/50 text-xs font-bold uppercase tracking-widest mb-5">
            Accreditations &amp; Memberships
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {accreditations.map((acc) => (
              <div
                key={acc.label}
                className="flex items-center gap-2 bg-navy-700/60 border border-gold-400/20 rounded-lg px-4 py-2.5"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${acc.icon} text-gold-400 text-sm`}></i>
                </span>
                <span className="text-gold-100/80 text-xs font-semibold whitespace-nowrap">{acc.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
